<template>
  <div class="bg-wrap">
    <div class="wrap">
      <div class="head-wrap" v-if="memberType">
        <div class="head-info">您的会员将于{{ endTime }}日到期</div>
      </div>

      <div class="memberInfo">
        <div class="tabs">
          <div :class="`tab ${tabIndex==0?'tab-active':''}`" @click="()=>{this.tabIndex=0;}">个人会员</div>
          <div :class="`tab ${tabIndex==1?'tab-active':''}`" @click="()=>{this.tabIndex=1;}">企业会员</div>
        </div>

        <div v-show="tabIndex==0" class="gr-wrap">
          <div class="items">
            <div v-for="(item,i) in items" :key="i" :class="`item ${item.id==selItemId?'item-active':''}`"
                 @click="()=>{selItemId=item.id;selItem=item;}">
              <div class="name">{{ item.mname }}</div>
              <div class="price">￥{{ item.mprice }}</div>
            </div>
          </div>
          <div :class="`btn ${selItemId>0?'btn-active':''}`" @click="()=>{selItemId&&buy()}">
            <span v-if="!memberType">立即开通</span>
            <span v-if="memberType">会员续费</span>
          </div>

          <div class="qy">
            <div class="title">VIP专属权益 | 助你变强大</div>

            <div class="list">
              <div class="item">
                <img class="img" src="../../assets/images/qy1.png" alt="">
                <div class="text">当月课程 免费尝鲜</div>
              </div>
              <div class="item">
                <img class="img" src="../../assets/images/qy2.png" alt="">
                <div class="text">600门好课 免费畅学</div>
              </div>
              <div class="item">
                <img class="img" src="../../assets/images/qy3.png" alt="">
                <div class="text">享有会员 优惠权益</div>
              </div>
              <div class="item">
                <img class="img" src="../../assets/images/qy4.png" alt="">
                <div class="text">专家坐席 贴心服务</div>
              </div>
              <div class="item">
                <img class="img" src="../../assets/images/qy5.png" alt="">
                <div class="text">会员尊贵 标识</div>
              </div>
            </div>
          </div>

          <div class="title">优质系列课程 | 会员免费</div>

          <div class="spList">

            <i-videolist :video_newest="videos"
                         v-on:success="()=>{}"></i-videolist>

            <div v-show="false" v-if="!page==1" class="more" @click="more">查看更多课程</div>
          </div>
        </div>

        <div v-show="tabIndex==1" class="enterprise">
          <table class="info" border="0" cellspacing="0" cellpadding="0">
            <tr class="th">
              <th class="tc">套餐</th>
              <th class="jg">价格(人民币)</th>
              <th class="nr">内容</th>
            </tr>
            <tr class="row">
              <td class="tc">套餐一</td>
              <td class="jg">3000元/年</td>
              <td class="nr">包含1个账号</td>
            </tr>
            <tr class="row2">
              <td class="tc">套餐二</td>
              <td class="jg">8400元/年</td>
              <td class="nr">包含3个员工账号 平均2800元/账号</td>
            </tr>
            <tr class="row">
              <td class="tc">套餐三</td>
              <td class="jg">12500元/年</td>
              <td class="nr">包含5个员工账号 平均2500元/账号</td>
            </tr>
            <tr class="row2">
              <td class="tc">套餐四</td>
              <td class="jg">20000元/年</td>
              <td class="nr">包含10个员工账号 平均2000元/账号</td>
            </tr>
             <tr class="row2">
              <td class="tc">套餐五</td>
              <td class="jg">35000元/年</td>
              <td class="nr">包含20个员工账号 平均1750元/账号</td>
            </tr>
             <tr class="row2">
              <td class="tc">套餐六</td>
              <td class="jg">65000元/年</td>
              <td class="nr">包含50个员工账号 平均1300元/账号</td>
            </tr>
          </table>

          <div class="ent-phone">
            购买企业会员，需拨打电话13811612257
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="支付提示"
      :visible.sync="payqrcode"
      width="30%"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <div style="text-align: center;" v-if="payqrcode">
        <p>支付金额：{{ this.curPrice }}元</p>
        <p>购买此课程，需微信扫码支付。</p>
        <div id="con_qrcode" ref="qrcode"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getHttp} from "../../plugin/extendFn/postHttp";
import iVideolist from '../container/videoList'
import QRCode from "qrcodejs2";
import loginService from '../../plugin/extendFn/loginService';
import AppSetting from '../../AppSetting';

export default {
  name: "vip",
  components: {
    iVideolist,
  },
  data() {
    return {
      endTime: "",
      tabIndex: 0,
      payqrcode: false,
      payfl: 0,
      timer: 0,
      curPrice: 0,

      wxuser: {},

      memberType: 0, // 0非会员，1：个人会员，2：企业会员

      items: [],
      selItemId: 0,

      selItem: {},

      videos: [],

      page: 0,
    }
  },
  filters: {
    getTimes(value) {
      if (!value) {
        return "";
      }
      return new Date(value).Format("yyyy.MM.dd");
    }
  },
  methods: {
    handleClose() {
      document.getElementById("con_qrcode").innerHTML = "";
      this.payqrcode = false;
      this.payfl = 0;
      window.clearInterval(this.timer)

    },
    getItems() {
      console.log(this)
      getHttp(AppSetting.baseUrl + '/memberitem/queryMemberItemList').then((res) => {
        if (res.data.code == 0) {
          let data = res.data.memberItmeList;
          console.log(data)
          this.items = data;
          this.selItem = this.items[0];
          this.selItemId = this.items[0].id;
        }

      })
    },

    getVipFreeVideos(page) {
      console.log(this)
      if (page >= 1) this.page = page;
      getHttp(`/ra-app/api/video/queryVideoList?pageNo=${page == 0 ? 1 : page}&pageSize=${page == 0 ? 20 : 20}`).then((res) => {
        if (res.data.code == 0) {
          let data = res.data.videoList;
          console.log(data)
          this.videos = page <= 1 ? data : this.videos.concat(data);
        }

      })
    },
    more() {
      this.getVipFreeVideos(this.page + 1)
    },
    toDetails(id) {
      this.$router.push({
        name: "vDetails",
        query: {type: "video", videoId: id}
      });
    },

    async info() {
      this.wxuser =await loginService.getLoginUser();
      if (!this.wxuser) return;
      this.$postHttp(AppSetting.baseUrl + "/student/info", {
        id: this.wxuser.uId
      }).then(async res => {
        if (res.data.code == 0) {
          this.wxuser = res.data.student;
          this.endTime = this.wxuser.uMemberEnd
          await loginService.setLoginUser(this.wxuser)
          let uMemberExpire = this.wxuser.uMemberExpire;
          let now = Date.now();
          this.uName = this.wxuser.uName;
          this.uGenre = this.wxuser.uGenre;
          this.uMemberExpire = this.wxuser.uMemberEnd;
          if (this.wxuser.uMemberType != null && this.wxuser.uMemberType != '') {
            this.memberType = this.wxuser.uMemberType;
          }
          console.log("-------------------------------------------------------------------"+this.memberType)
          if (now > uMemberExpire) {
            this.uGenre = 1;
          }
          this.sicon = this.wxuser.uIcon;
        }
      });
    },
   async  buy() {
      if (await loginService.isNotLogin()) {
        this.login();
      }
      else
      {
        this.wxuser =await loginService.getLoginUser();
        this.curPrice = this.selItem.mprice;
        this.subscribe(this.selItem.id);
      }
    },
    login () {
            loginService.login(this.$router)
            .then(loginUser=>{
              this.ra_wxUser=loginUser;
            })
          },
    //购买课程
    async subscribe(bid) {
      if (this.payfl == 1) {
        this.$message.warning('请勿重复点击！')
        return false
      }
     
      if(await loginService.isNotLogin())
      {
        this.login()
      }
      else {
        let ra_wxUser = await loginService.getLoginUser();

        console.log('微信登录信息----', ra_wxUser)
        if (ra_wxUser.uPhone && ra_wxUser.uOrg) {
          this.payfl = 1;
          if (this.curPrice == 0) {//0元不需要显示二维码 直接生成订单
            this.payqrcode = false;
          } else {
            this.payqrcode = true;
          }

          let param = {
            type: 1,
            orderType: 5, //4 vip购买，1 视频购买，2直播购买，3专栏购买
            bId: bid,
            payPrice: this.curPrice,
            uid: ra_wxUser.uId
          };
          this.$postHttp(AppSetting.baseUrl + "/order/app/add", param).then(res => {
            if (res.data.code == 0) {

              if (this.curPrice == 0) {
                this.$message.success('支付成功！');
                location.reload()
                return false;

              }
              const pay_params = JSON.parse(res.data.parMap);
              const orderid = res.data.id;//订单号 用于查询支付状态
              console.log('支付信息', pay_params);
              let qrcode = new QRCode(this.$refs.qrcode, {
                text: pay_params.code_url,
                width: 200,
                height: 200,
                colorDark: "#333333", //二维码颜色
                colorLight: "#ffffff", //二维码背景色
                correctLevel: QRCode.CorrectLevel.H//容错率，L/M/H
              });

              this.timer = setInterval(() => {
                this.$postHttp(AppSetting.baseUrl + '/order/app/search', {id: orderid}).then((result) => {
                  console.log(result)
                  if (result.data.code == 0) {//data.orderStatus 0未支付，1支付成功，2支付失败
                    if (result.data.data.orderStatus == 1) {
                      this.$message.success('支付成功！');
                      document.getElementById("con_qrcode").innerHTML = "";
                      window.clearInterval(this.timer);
                      location.reload()
                      this.payqrcode = false;
                    } else if (result.data.data.orderStatus == 2) {
                      this.$message.success('支付失败！');
                      window.clearInterval(this.timer);
                      document.getElementById("con_qrcode").innerHTML = "";
                      this.payqrcode = false;
                    }

                  } else if (result.data.code == 2004) {
                    this.$message.error('订单号为空')
                  } else {
                    this.$message.error('查询失败')
                  }

                })

              }, 2000)

            } else {
              this.$message.error(res.data.msg)
            }
          });

        }
      }
    },
  },
  computed: {
    routerName() {
      return this.$route.name
    }
  },
  mounted() {
    this.info();
    this.getItems();
    this.getVipFreeVideos(0);
  },
}
</script>

<style lang="scss" scoped>
.bg-wrap {
  background: url("../../assets/images/vip_bg.png") top no-repeat;
  background-size: 100%;
  min-height: 100vh;
  min-width: 100vh;

  margin-top: 0 !important;

  .wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
  }

  .head-wrap {
    background: #499EF2;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
  }

  .head-info {
    min-width: 1176px;

    line-height: 50px;


    font-size: 14px;
    font-family: SourceHanSansCN;
    font-weight: 500;
    color: #FFFFFF;
  }

  .memberInfo {
    min-width: 1176px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .tabs {
      border-radius: 10px;
      background-color: #ffffff;
      font-size: 20px;

      margin-top: 50px;

      width: 460px;

      display: flex;
      justify-content: space-between;
      text-align: center;

      color: #623B01;

      cursor: default;

      .tab {
        flex: 1;
        height: 58px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 230px;

        &-active {
          background: linear-gradient(-90deg, #FDC45A 0%, #FADCA0 100%);
          //color: #623B01;
        }
      }

      :first-child {
        border-radius: 10px 0 0 10px;
      }

      :last-child {
        border-radius: 0 10px 10px 0;
        border-left: 0;
      }
    }


    .gr-wrap {

      min-width: 1176px;

      .items {
        display: flex;
        justify-content: center;

        margin-top: 40px;

        .item {
          background: url("../../assets/images/vip_card_bg.png") no-repeat;
          background-size: 100% 100%;

          width: 200px;
          height: 104px;

          margin-right: 70px;

          &:last-child {
            margin-right: 0;
          }


          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .name {
            font-size: 19px;
            font-family: SourceHanSansCN;
            font-weight: bold;
            color: #644931;
          }

          .price {
            font-size: 26px;
            font-family: SourceHanSansCN;
            font-weight: 400;
            color: #EE310D;
          }

          .price:first-letter {
            font-size: 16px;
          }

          &-active {
            background: url("../../assets/images/vip_card_bg_sel.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }

      .title {
        font-size: 24px;
        color: #4C4B4B;

        margin: 30px 0;
      }

      .qy {


        .list {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;

          .item {
            display: flex;
            flex-direction: column;
            align-items: center;


            margin: 20px 45px;

            width: 100px;

            .img {
              width: 58px;
              height: 58px;
            }

            .text {
              margin-top: 10px;
              font-size: 16px;
              font-family: SourceHanSansCN;
              font-weight: 400;
              color: #666666;
              text-align: center;
              width: 80px;
            }
          }
        }
      }

      .spList {
        .item {
          display: flex;
          padding: .2rem;
          background-color: #ffffff;
          border-radius: .08rem;

          margin-bottom: .2rem;

          .img {
            min-width: 2.84rem;
            height: 1.6rem;
            margin-right: 0.22rem;
          }

          .info {
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .tit {
              font-size: .28rem;
              font-family: SourceHanSansCN;
              font-weight: bold;
              color: #333333;
              line-height: .36rem;
            }

            .other {
              display: flex;
              justify-content: space-between;
              align-items: center;
            }

            .left {
              font-size: .22rem;
              font-family: SourceHanSansCN;
              font-weight: 400;
              color: #666666;
              line-height: .28rem;
            }

            .right {
              font-size: .36rem;
              font-family: SourceHanSansCN;
              font-weight: 400;
              color: #F00000;
              line-height: .28rem;
            }
          }
        }

        .more {
          margin-top: 20px;
          text-align: center;
          padding: 20px;

          font-size: 16px;
          color: #2E96FE;
        }
      }

      .btn {
        width: 300px;
        height: 52px;
        // background: linear-gradient(90deg, #FDC358 0%, #FADDA3 100%);
        background: #aaaaaa;
        border-radius: 10px;

        margin: 30px auto;

        text-align: center;
        line-height: 52px;

        font-size: 18px;
        color: #ffffff;

        &-active {
          background: #2E96FE;
        }
      }
    }


    .enterprise {

      font-size: 18px;

      margin-top: 40px;

      .info {

        width: 900px;
        //height: 480px;
        background: #FFFFFF;
        box-shadow: 3px 4px 9px 1px rgba(217, 217, 217, 0.5);
        border-radius: 10px;

        td, th {
          height: 60px;
          text-align: center;
        }

        .th {
          background: #61C5FF;
          color: #ffffff;
        }

        .nr {
          width: 320px;
        }

        .row {
          color: #666666;
        }

        .row2 {
          background: rgba(220, 242, 255, 1);
          color: #666666;
        }
      }

      .ent-phone {
        position: absolute;
        left: 0;
        right: 0;

        text-align: center;

        height: 80px;
        background: #FFF6E6;
        border-radius: 10px;
        margin-top: 40px;

        font-size: 20px;
        font-family: SourceHanSansCN;
        font-weight: 500;
        color: #D0911E;
        line-height: 80px;
      }
    }
  }

  #con_qrcode {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/me/vip.vue